import { UserNavItemsContainer } from './user-nav-item-container';
import { type PropsWithChildren } from 'react';
import cx from 'classnames';
import { LanguageSelector } from '@dx-ui/osc-language-selector';
import { useHeaderContext } from '../../../context/header-context';

export const UserNavContainer = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  const {
    navigation: { languageSelectorOptions },
  } = useHeaderContext();

  return (
    <div className={cx('absolute end-0 top-0', className)}>
      <UserNavItemsContainer>
        {languageSelectorOptions ? (
          <li className="osc-nav-list-item flex h-full items-center border-t-4 border-y-transparent px-1">
            <LanguageSelector {...languageSelectorOptions} />
          </li>
        ) : null}

        {children}
      </UserNavItemsContainer>
    </div>
  );
};
